module.exports = __webpack_public_path__ + "img/t_7.4c970dfc.png";